import React from 'react'
import WizardStepBase from '../base'
import { Link, withRouter } from 'react-router-dom'

import constants from '../../../constants'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as orderActions from '../../../actions/order_actions';
import _ from 'lodash';

import SimpleOptionsList from 'app/components/simple_options_list'

class WizardStepFive extends WizardStepBase{
  constructor(props) {
    super(props);
    this.stepNum = 5;
  }

  render() {
    return (
      <div>
        <h1>Дополнительные опции</h1>
        <SimpleOptionsList onSelect={this.props.order_actions.constructionPartSelected}
                           collection={this.props.parts_state.AdditionalOption}
                           selectedItems={this.props.order_state.groups.parts}
        />

        <div className="mobile-show">
          <Link onClick={this.stepChange} className='back-link' to={constants.ROUTES.STEP4}>Назад к замкам и фурнитуре</Link>
        </div>
        <Link onClick={this.stepChange} className='button button-red button-large wizard-next-action-button' to={constants.ROUTES.ORDER}>
          <span>Перейти к заказу</span>
        </Link>
        <div className="mobile-hidden">
          <Link className='back-link' to={constants.ROUTES.STEP4}>Назад к замкам и фурнитуре</Link>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    constructions_state: state.constructionsState,
    order_state: state.orderState,
    app: state.applicationState,
    parts_state: state.partsState
  }
};

const mapDispatch = (dispatch) => {
  return {
    order_actions: bindActionCreators(orderActions, dispatch)
  };
};

export default withRouter(connect(mapStateToProps, mapDispatch, null, {pure: false})(WizardStepFive));




// WEBPACK FOOTER //
// ./app/javascript/app/pages/wizard_steps/step_5/index.jsx